module.exports = __webpack_public_path__ + "img/appAsset-brand--axteroid-icon-test.0449d26a.svg";